import NavMain from './components/nav-main/nav-main';
import BlockBranding from './components/block-branding/block-branding';
import ParagraphTypeFact from './components/paragraph-type-fact/paragraph-type-fact';
import FieldCards from './components/field-cards/field-cards';
import SanArenaRs from './components/sanarenars/sanarenars';

console.info('Starting JavaScript stack');

const navMain = new NavMain();
navMain.run();

const blockBranding = new BlockBranding();
blockBranding.run();

const paragraphTypeFact = new ParagraphTypeFact();
paragraphTypeFact.run();

const fieldCards = new FieldCards();
fieldCards.run();

const sanArenaRs = new SanArenaRs();
sanArenaRs.run();
